module.exports = __webpack_public_path__ + "assets/3352a2de85e01c2e0c221c98818c4f2d.svg";